<template>
    <div>
      <v-row no-gutters align="center">
        <v-col cols="6">
          <modal-cadu :close="close" :width="740" v-model="show">
              <div slot="all" v-if="step == 0" class="py-12 px-0">
                  <div slot="header" v-if="!trocarDados">
                      <div style="text-align: center" class="font-primaria display-1 font-weight-bold fontColor1--text">
                      Olá, esse é seu primeiro acesso ao Cadu
                      </div>
                      <div style="text-align: center" class="subtitle-2 font-weight-regular fontColor1--text">
                      Antes de começarmos solicitamos a confirmação dos seguintes campos:
                      </div>
                  </div>
                  <div slot ="header" v-else>
                      <div style="text-align: center" class="font-primaria display-1 font-weight-bold fontColor1--text">
                      Editar Perfil
                      </div>
                  </div>
                  <div slot="body">
                      <v-row no-gutters align="center" justify="center">
                          <v-col cols="14" sm="10" md="6">
                              <FormModal ref="formModal"/>
                          </v-col>
                      </v-row>
                  </div>
                  <div slot="footer">
                    <v-row no-gutters align="center" justify="center">
                      <v-col cols="10">
                        <v-row align="center" justify="center">
                            <checkbox-cadu v-model="check" ref="check" :color="$vuetify.theme.themes.light.primary1" :textColor="$vuetify.theme.themes.light.fontColor2" v-if="!trocarDados">
                            </checkbox-cadu>
                              <div slot="text">
                                Li e concordo com os termos | Para visualizar
                                <a
                                  @click.stop
                                  target="_blank"
                                  :href="url"
                                  class="primary1--text"
                                  style="text-decoration: underline;"
                                > clique aqui </a>
                              </div>
                        </v-row>
                      </v-col>
                      <br />
                      <br />
                      <br />
                      <v-col :cols="$vuetify.breakpoint.width <= 330 ? '12' : '11'" sm="8" md="5">
                        <v-row no-gutters align="center" justify="start">
                            <v-col cols="auto">
                                <a @click="toFoto" class="under ml-1 primary1--text" v-if="!trocarDados">
                                  Inserir Foto
                                </a>
                            </v-col>
                            <v-row no-gutters align="center" justify="end" v-if="!trocarDados">
                                <v-col cols="auto">
                                  <button-cadu :loading="loadingImage" @click="validateForm" :disabled="buttonDisabled" text="SALVAR"/>
                                </v-col>
                            </v-row>
                            <v-row no-gutters align="center" justify="center" v-if="trocarDados">
                                <v-col cols="auto">
                                  <button-cadu :loading="loadingImage" @click="validateForm" :disabled="buttonDisabled" text="SALVAR"/>
                                </v-col>
                            </v-row>
                        </v-row>
                      </v-col>
                    </v-row>
                  </div>
              </div>
              <div slot="all" class="py-12" v-if="step == 1">
                  <div slot="body">
                      <v-row style="position: relative;" no-gutters align="center" justify="center">
                          <input
                              type="file"
                              @input="filesChange($event)"
                              accept=".jpg, .jpeg, .png"
                              class="input-file"
                              :value="fileInput"
                          >
                          <v-col cols="auto">
                              <div v-if="!image || image === 'url' ">
                                  <icon class="primary1--text" name="image" :size="100"/>
                              </div>
                              <div v-else>
                                  <v-img height="129" width="129" style="border-radius: 100px;" :src="image" />
                              </div>
                          </v-col>
                      </v-row>
                      <v-row class="pt-8 pb-7" no-gutters align="center" justify="center">
                          <v-col cols="auto">
                              <v-row no-gutters align="center" justify="center">
                                  <v-col cols="auto">
                                      <div>
                                          <a style="position: relative;" class="under font-secundaria display-1 primary1--text">
                                              Carregue uma foto
                                              <input
                                                  type="file"
                                                  @input="filesChange($event)"
                                                  accept=".jpg, .jpeg, .png"
                                                  class="input-text"
                                                  :value="fileInput"
                                              >
                                          </a>
                                      </div>
                                  </v-col>
                              </v-row>
                              <v-row v-if="validateSizeFile" no-gutters align="center" justify="center">
                                <v-col cols="auto">
                                  <a class="font-secundaria red--text"  style="font-size: 15px;" >
                                       O Arquivo deve ter tamanho igual ou inferior a 500KB.
                                  </a>
                                </v-col>
                              </v-row>
                              <v-row v-if="validateTypeSize" no-gutters align="center" justify="center">
                                <v-col cols="auto">
                                  <a class="font-secundaria red--text"  style="font-size: 15px;" >
                                       O Arquivo deve ser JPG, JPEG ou PNG.
                                  </a>
                                </v-col>
                              </v-row>
                              <v-row v-if="image != 'url'" class="pt-3 pb-1" no-gutters align="center" justify="center">
                                  <v-col cols="auto">
                                      <a @click="removeImage" class="under font-secundaria title grey1--text">
                                          Remover Foto
                                      </a>
                                  </v-col>
                              </v-row>
                          </v-col>
                      </v-row>
                  </div>
                  <div slot="footer">
                    <v-row no-gutters align="center" justify="center" v-if="!$vuetify.breakpoint.xs">
                      <v-col cols="6">
                        <v-row>
                          <v-col cols="6">
                            <button-cadu
                              text="CANCELAR"
                              @click="cancelarFoto"
                              :outline="true"
                              :large="true"
                            />
                          </v-col>
                          <v-col cols="6">
                            <button-cadu :loading="loadingImage" @click="putData" :large="true" text="OK" />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row v-else class="px-8">
                      <v-col cols="12">
                        <button-cadu
                          :loading="loadingImage"
                          @click="putData"
                          :large="true"
                          text="OK"
                          block
                        />
                      </v-col>
                      <v-col cols="12">
                        <button-cadu
                          text="CANCELAR"
                          block
                          @click="cancelarFoto"
                          :outline="true"
                          :large="true"
                        />
                      </v-col>
                    </v-row>
                      <!-- <v-row no-gutters align="center" justify="center">
                          <v-col cols="auto">
                              <button-cadu :loading="loadingImage" @click="putData" :large="true" text="OK" />
                          </v-col>
                      </v-row>
                      <v-row no-gutters class="pt-3 pb-1" align="center" justify="center">
                        <v-col cols="auto">
                            <button-cadu
                              text="CANCELAR"
                              @click="cancelarFoto"
                              :outline="true"
                            />
                        </v-col>
                      </v-row> -->
                  </div>
              </div>
          </modal-cadu>
        </v-col>
      </v-row>
      <ErrorModal v-model="error" :errObj="errObj" />
    </div>
</template>

<script>
import FormModal from './FormModal'
import Usuario from '@/services/Usuario'
import ErrorModal from '@/components/Shared/ErrorModal/ErrorModal'

export default {
  name: 'PendenciaModal',
  components: {
    FormModal,
    ErrorModal
  },
  props: {
    pendencia: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      show: this.pendencia,
      data: {},
      step: 0,
      image: localStorage.getItem('fotoPerfil') !== 'url' ? localStorage.getItem('fotoPerfil') : 'url',
      fileInput: '',
      disabled: false,
      inputFile: undefined,
      formData: new FormData(),
      onlyImage: false,
      check: false,
      loadingImage: false,
      close: false,
      error: false,
      errObj: {},
      url: '',
      api: '',
      trocarDados: false,
      validateCheck: false,
      validateSizeFile: false,
      validateTypeSize: false,
      cancelar: false,
      tokenBearer: '',
      removeuImagem: false,
      fotoUsuario: ''
    }
  },
  beforeMount () {
    this.api = this.$appConfig.config.API
    this.url = window.location.origin + this.$appConfig.config.TERMOS
  },
  computed: {
    buttonDisabled () {
      return this.disabled
    }
  },
  methods: {
    async validateForm () {
      this.loadingImage = true
      const validate = await this.$refs.formModal.validate()

      if (!this.trocarDados) {
        this.validateCheck = this.$refs.check.validate()
      } else {
        this.validateCheck = true
      }
      if (validate !== false && this.validateCheck) {
        let usuario = new Usuario(localStorage.getItem('tokenBearer'), this.api)

        try {
          await usuario.putData(validate)
          this.$emit('reload')
          this.show = false
          this.loadingImage = false
        } catch (err) {
          this.error = true
          this.loadingImage = false
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        }
      }
      this.loadingImage = false
    },
    async toFoto (evt) {
      const validate = await this.$refs.formModal.validate()
      if (!this.trocarDados) {
        this.validateCheck = this.$refs.check.validate()
      } else {
        this.validateCheck = true
      }
      if (validate !== false && this.validateCheck) {
        this.step++
        this.data = validate
      }
    },
    async putData () {
      this.loadingImage = true
      if ((this.inputFile && !this.onlyImage) || this.cancelar === true) {
        let usuario = new Usuario(localStorage.getItem('tokenBearer'), this.api)
        try {
          // eslint-disable-next-line
          if (this.image != 'url') {
            this.formData.append('foto', this.inputFile)
            this.inputFile = undefined
            await usuario.putImage(this.formData)
          }
          // eslint-disable-next-line
          let responseData = await usuario.putData(this.data)

          this.$emit('reload')
          this.loadingImage = false
          this.show = false
          this.image = ''
        } catch (err) {
          this.error = true
          this.loadingImage = false
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        }
      } else if ((this.inputFile && this.onlyImage) || (this.removeuImagem && this.onlyImage)) {
        let usuario = new Usuario(localStorage.getItem('tokenBearer'), this.api)

        try {
          this.formData.append('foto', this.inputFile)
          this.inputFile = undefined

          if (!this.removeuImagem) {
            await usuario.putImage(this.formData, this.api)
            localStorage.setItem('fotoPerfil', this.image)
          } else {
            await usuario.delImage()
            localStorage.setItem('fotoPerfil', 'url')
          }
          // eslint-disable-next-line

          this.$emit('reload')
          this.loadingImage = false
          this.show = false
          this.image = ''
        } catch (err) {
          this.error = true
          this.loadingImage = false
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        }

        this.loadingImage = false
      } else {
        this.loadingImage = false
      }
    },
    async filesChange (e) {
      this.fileInput = ''
      this.inputFile = undefined
      this.formData = new FormData()

      this.image = ''
      let files = e.target.files || e.dataTransfer.files
      this.inputFile = files[0]
      let file = files[0]

      if (this.inputFile.size <= 500000) {
        if (file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg') {
          this.validateTypeSize = false
          this.validateSizeFile = false
          this.removeuImagem = false
          this.createImage(files[0])
        } else {
          this.validateTypeSize = true
        }
      } else {
        this.validateSizeFile = true
      }
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this

      reader.onloadend = (e) => {
        vm.image = e.target.result
      }

      reader.readAsDataURL(file)
    },
    removeImage () {
      this.removeuImagem = true
      this.cleanImagem()
    },

    cleanImagem () {
      this.image = 'url'
    },
    cancelarFoto () {
      this.cleanImagem()

      if (!this.onlyImage) {
        this.cancelar = true
        this.putData()
      } else {
        this.show = false
        this.loadingImage = false
      }
    }
  },
  watch: {
    check () {
      if (this.check) {
        this.$refs.check.error = false
      }
    },
    pendencia () {
      this.show = this.pendencia
    },
    show () {
      if (!this.show) {
        this.image = localStorage.getItem('fotoPerfil') !== 'url' ? localStorage.getItem('fotoPerfil') : 'url'
        this.validateTypeSize = false
        this.validateSizeFile = false
        this.removeuImagem = false
        this.inputFile = undefined
        this.$emit('close')
      }
    }
  },
  mounted () {
    this.showData = this.show
  }
}
</script>

<style lang="sass" scoped>
.under
  text-decoration: underline !important
.form-image
    position: relative

.text-error
    color:#FF0000

.input-file
    opacity: 0
    position: absolute
    top: 0
    height: 100%
    width: 70%
    &:hover
        cursor: pointer

.input-text
  opacity: 0
  position: absolute
  top: 0
  left: 0
  height: 100%
  width: 100%
  &:hover
    cursor: pointer
</style>
